module.exports = __webpack_public_path__ + "img/product28803.b0df10a5.png";